// Файл policy_file_actions.js

/**
 * Модуль инкапсулирует загрузку и открытие файлов политик через существующие методы API приложения.
 */

import { apiService } from '../../services/api';



export const load_policy_file_blob = (
    table_name,
    document_id,
    file_name,
) => apiService.get_file_blob_POST(
    table_name,
    {
        ID_document: document_id,
        file: file_name,
    },
);


export const download_policy_file = async (
    table_name,
    document_id,
    file_name,
) => {
    const blob = await load_policy_file_blob(
        table_name,
        document_id,
        file_name,
    );
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = String(file_name || 'policy.pdf');
    document.body.appendChild(link);
    link.click();
    link.remove();

    setTimeout(
        () => window.URL.revokeObjectURL(url),
        1000,
    );
};
